import { Station } from '@mi-front/core';

export function isTranscriptionEnabled(station: Station) {
  return Boolean(station.featuresConfig?.transcription?.enabled);
}

export function isDiarizationSegmentsEnabled(station: Station) {
  return (
    Boolean(station.featuresConfig?.transcription?.enabled) &&
    Boolean(station.featuresConfig?.transcription?.diarization?.segments)
  );
}

export function isDiarizationFragmentsEnabled(station: Station) {
  return (
    Boolean(station.featuresConfig?.transcription?.enabled) &&
    Boolean(station.featuresConfig?.transcription?.diarization?.fragments)
  );
}
